module.exports = require("@trendmicro/react-buttons");


//////////////////
// WEBPACK FOOTER
// external "@trendmicro/react-buttons"
// module id = 8
// module chunks = 0